/**
 * Accordion component
 */

const njamitoAccordionAnchorElements = document.querySelectorAll('.njamito-accordion__type--anchor') as NodeListOf<HTMLInputElement>;

document.querySelectorAll('.njamito-accordion__type--anchor[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
        e.preventDefault();
        const targetId = (anchor as HTMLAnchorElement).getAttribute('href');
        if (targetId) {
            const targetElement = document.querySelector(targetId);
            if (targetElement) {
                const rect = targetElement.getBoundingClientRect();
                const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                const targetY = rect.top + scrollTop - 80;

                window.scrollTo({
                    top: targetY,
                    behavior: 'smooth'
                });
            }
        }
    });
});

document.querySelectorAll('.njamito-accordion__item-content').forEach(content => {
    const contentHeight = content.scrollHeight;
    const contentStyle = window.getComputedStyle(content);
    const paddingTop = parseFloat(contentStyle.paddingTop);
    const paddingBottom = parseFloat(contentStyle.paddingBottom);
    const marginTop = parseFloat(contentStyle.marginTop);
    const marginBottom = parseFloat(contentStyle.marginBottom);
    const totalHeight = contentHeight + paddingTop + paddingBottom + marginTop + marginBottom;
    (content as HTMLElement).style.setProperty('--njamito-accordion-item-content-max-height', totalHeight + 'px');
});

/**
 * Quantity component
 */

//const njamitoQuantityElements = document.querySelectorAll(".njamito-quantity__input");
const njamitoQuantityElements = document.querySelectorAll(".njamito-quantity__input") as NodeListOf<HTMLInputElement>;


if (njamitoQuantityElements) {
    njamitoQuantityElements.forEach((element) => {
        const fieldId = element.id;
        const quantityAdd = document.getElementById(fieldId + "-add") as HTMLButtonElement;
        const quantitySubtract = document.getElementById(fieldId + "-subtract") as HTMLButtonElement;
        const quantityValue = document.getElementById(fieldId + "-value") as HTMLDivElement;

        // Ensure buttons exist before adding event listeners
        if (quantityAdd) {
            quantityAdd.addEventListener("click", () => {
                njamitoSetQuantity(fieldId, 1);
            });
        }

        if (quantitySubtract) {
            quantitySubtract.addEventListener("click", () => {
                njamitoSetQuantity(fieldId, -1);
            });
        }

        element.addEventListener("change", (event) => {
            const inputElement = event.target as HTMLInputElement;
            if (quantityValue) {
                quantityValue.textContent = inputElement.value;
            }
            updateButtonState(fieldId);
            updateAddToCartQuantity(element);
        });

        // Seed the visible value on load. Grouped-product rows ship an empty
        // field, which would otherwise render a blank gap between -/+.
        if (quantityValue && quantityValue.textContent?.trim() === "") {
            const initial = parseInt(element.value);
            const initialMin = element.min ? parseInt(element.min) : 1;
            quantityValue.textContent = String(Number.isNaN(initial) ? initialMin : initial);
        }

        // Initialize button state on load
        updateButtonState(fieldId);
        updateAddToCartQuantity(element);
    });
}

function njamitoSetQuantity(fieldId: string, changeValue: number) {
    const field = document.getElementById(fieldId) as HTMLInputElement;
    const quantityValue = document.getElementById(fieldId + "-value") as HTMLDivElement;

    if (!field || !quantityValue) return;

    // Ensure min & max values are handled correctly
    const minValue = field.min ? parseInt(field.min) : 1;
    const maxValue = field.max ? parseInt(field.max) : Infinity;

    // Grouped (bundle) products render their child rows with an empty value and
    // min="0", so parseInt() yields NaN. Fall back to the minimum, otherwise the
    // arithmetic below stays NaN and `type="number"` silently discards the write.
    const currentValue = parseInt(field.value);
    const baseValue = Number.isNaN(currentValue) ? minValue : currentValue;

    let newValue = baseValue + changeValue;

    newValue = Math.max(minValue, Math.min(newValue, maxValue));

    field.value = newValue.toString();
    quantityValue.textContent = newValue.toString(); // Update displayed value

    field.dispatchEvent(new Event("change"));

    // Update button states after change
    updateButtonState(fieldId);
    updateAddToCartQuantity(field);
}

function updateButtonState(fieldId: string) {
    const field = document.getElementById(fieldId) as HTMLInputElement;
    const quantityAdd = document.getElementById(fieldId + "-add") as HTMLButtonElement;
    const quantitySubtract = document.getElementById(fieldId + "-subtract") as HTMLButtonElement;

    if (!field || !quantityAdd || !quantitySubtract) return;

    const minValue = field.min ? parseInt(field.min) : 1;
    const maxValue = field.max ? parseInt(field.max) : Infinity;

    // An empty grouped-product field reads as NaN; treat it as the minimum so the
    // subtract button starts disabled instead of comparing against NaN.
    const parsedValue = parseInt(field.value);
    const currentValue = Number.isNaN(parsedValue) ? minValue : parsedValue;

    // Disable or enable subtract button
    quantitySubtract.disabled = currentValue <= minValue;
    quantityAdd.disabled = currentValue >= maxValue;
}

function updateAddToCartQuantity(inputElement: HTMLInputElement) {
    // Find the closest WooCommerce product container
    const productContainer = inputElement.closest(".product");
    if (!productContainer) return;

    // Find the "Add to Cart" button inside this product
    const addToCartButton = productContainer.querySelector(".add_to_cart_button") as HTMLAnchorElement;
    if (addToCartButton) {
        addToCartButton.setAttribute("data-quantity", inputElement.value);
    }
}

/**
 * Select-Dropdown component
 */

const njamitoSelectElements = document.querySelectorAll('.njamito-select');
if (njamitoSelectElements) {
    document.addEventListener("click", (event) => {
        njamitoSelectElements.forEach((select) => {
            const id = select.getAttribute('data-id');
            const input = id ? document.getElementById(id) as HTMLInputElement : null;
            if (input && !select.contains(event.target as Element)) {
                input.checked = false;
            }
        });
    });
}